import {
  validatePresence,
  validateFormat,
} from 'ember-changeset-validations/validators';

export default {
  name: validatePresence(true),
  roadmap_url: [validateFormat({ type: 'url', allowBlank: true })],
};
